import * as React from 'react';
import { IconCommunicationComment16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ReviewAnswers.css';

export interface IReviewAnswersProps {
  url: string;
  answersCount: string;
}

export const ReviewAnswers: React.FC<IReviewAnswersProps> = ({ answersCount, url }) => {
  return (
    <a className={styles['component']} href={url}>
      <IconCommunicationComment16 color="current_color" /> <div className={styles['label']}>{answersCount}</div>
    </a>
  );
};
